var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivilagesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 1.63986C10.6919 1.63986 8.40982 1.22065 6.64478 0.0438651C6.60191 0.0152636 6.55153 0 6.49999 0C6.44846 0 6.39808 0.0152636 6.35521 0.0438651C4.59017 1.22065 2.30809 1.63986 0.760869 1.63986C0.691682 1.63986 0.625329 1.66735 0.576407 1.71627C0.527484 1.76519 0.5 1.83155 0.5 1.90073C0.5 6.62899 2.70461 10.3965 6.39721 11.9789C6.42969 11.9928 6.46466 12 6.49999 12C6.53533 12 6.5703 11.9928 6.60278 11.9789C10.2954 10.3965 12.5 6.62899 12.5 1.90073C12.5 1.83155 12.4725 1.76519 12.4236 1.71627C12.3747 1.66735 12.3083 1.63986 12.2391 1.63986ZM6.23913 0.730473V5.73916H1.58991C1.23016 4.57874 1.03959 3.3725 1.02409 2.15769C2.85154 2.10573 4.63988 1.61631 6.23913 0.730473ZM6.76086 11.3272V6.2609H11.2301C10.46 8.46879 8.85564 10.2871 6.76086 11.3262V11.3272Z",
    fill: "#6D5DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilagesIcon);
export default __webpack_public_path__ + "static/media/privilages_icon.b4a5ae5d0057d08113e7eaf2547e10b8.svg";
export { ForwardRef as ReactComponent };